import { useCallback } from "react";

import { useMutation } from "@apollo/client";

import { type ApolloResult } from "../../shared/models";
import {
    type SaveRemoteApiSpecMutation,
    type SaveRemoteApiSpecMutationVariables,
    getRemoteApiSpec,
    saveRemoteApiSpec,
} from "../api/graphql";

export const useSaveRemoteApiSpec = (): ApolloResult<{
    saveRemoteApiSpec: (remoteApiSpec: SaveRemoteApiSpecMutationVariables) => Promise<void>;
    updatedSpecId: string | null;
}> => {
    const [saveSpec, { error, loading, data }] = useMutation<
        SaveRemoteApiSpecMutation,
        SaveRemoteApiSpecMutationVariables
    >(saveRemoteApiSpec);

    const performSaveSpec = useCallback(
        async (remoteApiSpec: SaveRemoteApiSpecMutationVariables) => {
            await saveSpec({
                variables: remoteApiSpec,
                refetchQueries: remoteApiSpec.id
                    ? [
                          "getRemoteApiSpecs",
                          {
                              query: getRemoteApiSpec,
                              variables: { specId: remoteApiSpec.id },
                          },
                      ]
                    : ["getRemoteApiSpecs"],
            });
        },
        [saveSpec],
    );

    return { saveRemoteApiSpec: performSaveSpec, error, loading, updatedSpecId: data?.saveRemoteApiSpec.id ?? null };
};
